import { FormGroup, Input, Select } from '../../components/Form';

export const EntradasSection = ({ entradas, onChange, onAdd, onRemove }) => (
    <div className="card" style={{ marginBottom: '1.25rem' }}>
        <p className="section-label">Entradas</p>

        {entradas.map((entrada, idx) => (
            <div key={idx} style={{
                background: 'var(--canvas)',
                border: '1px solid var(--glass-border)',
                borderRadius: '10px',
                padding: '1rem',
                marginBottom: idx < entradas.length - 1 ? '0.75rem' : 0,
            }}>
                {entradas.length > 1 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                        <span style={{ color: 'var(--muted)', fontWeight: 600, fontSize: '0.775rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                            Entrada {idx + 1}
                        </span>
                        <button
                            type="button"
                            onClick={() => onRemove(idx)}
                            style={{ background: 'none', border: 'none', color: 'var(--danger-soft)', cursor: 'pointer', fontSize: '0.8125rem', padding: 0 }}
                        >
                            Remover
                        </button>
                    </div>
                )}
                <div className="grid-3">
                    <FormGroup label="Valor (R$)" htmlFor={`valorEntrada-${idx}`}>
                        <Input
                            id={`valorEntrada-${idx}`}
                            value={entrada.valor}
                            onChange={e => onChange(idx, 'valor', e.target.value)}
                            placeholder="0,00"
                        />
                    </FormGroup>
                    <FormGroup label="Método" htmlFor={`formaEntrada-${idx}`}>
                        <Select
                            id={`formaEntrada-${idx}`}
                            value={entrada.formaPagamento}
                            onChange={e => onChange(idx, 'formaPagamento', e.target.value)}
                        >
                            <option value="">Selecione</option>
                            <option value="Pix">Pix</option>
                            <option value="Cartão de Crédito">Cartão de Crédito</option>
                            <option value="Transferência Bancária">Transferência Bancária</option>
                            <option value="Dinheiro">Dinheiro</option>
                        </Select>
                    </FormGroup>
                    <FormGroup label="Data" htmlFor={`dataEntrada-${idx}`}>
                        <Input
                            type="date"
                            id={`dataEntrada-${idx}`}
                            value={entrada.data}
                            onChange={e => onChange(idx, 'data', e.target.value)}
                        />
                    </FormGroup>
                </div>
            </div>
        ))}

        <button
            type="button"
            onClick={onAdd}
            className="pill pill-ghost pill-sm"
            style={{ marginTop: '0.875rem', borderStyle: 'dashed' }}
        >
            + Adicionar Entrada
        </button>
    </div>
);
